/* eslint-disable */
/**
 * @author Rahul Nainala
 * @description Loads multiple 3D Model
 */
import React, { useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import ModelInstance from './modelInstance';

export const ModelLoader = ({
    colorHelper,
    config,
    selectedMesh,
    setSelectedMesh,
    groupRef,
    selectedObjectNameGlobal,
    setShouldAnimateCamera
}) => {
    const models = useMemo(() => {
        return config.map(item => ({
            name: item.name,
            gltf: useGLTF(item.path),
        }));
    }, [config]);

    const handleClick = (e) => {
        e.stopPropagation();
        setShouldAnimateCamera(false);
        const intersections = e.intersections;
        if (!intersections || intersections.length === 0) return;
        const firstIntersection = intersections[0];
        if (!firstIntersection.object.userData.isClickable) return;
        const object = firstIntersection.object;
        if (!object.isMesh) return;
        if (groupRef.current) {
            groupRef.current.traverse((node) => {
                if (node.isMesh) {
                    if (node.userData.originalColor) {
                        node.material.color.set(node.userData.originalColor);
                    } else {
                        node.material.color.set("#ffffff");
                    }
                }
            });
        }
        if (!object.userData.originalColor) {
            object.userData.originalColor = object.material.color.clone();
        }
        object.material.color.set(colorHelper || "#ff0000");
        setSelectedMesh(object);
    };

    return (
        <group ref={groupRef}>
            {config.map((item, index) => {
                let model = models.find(m => m.name === item.name);
                if (!model) return null;
                if (item.clickable === true) {
                    return (
                        <ModelInstance
                            key={index}
                            gltf={model.gltf}
                            name={item.name}
                            clickable={item.clickable}
                            scale={item.scale || [1, 1, 1]}
                            position={[item.x, 0, item.z]}
                            onClick={handleClick}
                            isSelected={selectedObjectNameGlobal === item.name}
                            colorHelper={colorHelper}
                        />
                    )
                } else {
                    return (
                        <ModelInstance
                            key={index}
                            gltf={model.gltf}
                            name={item.name}
                            clickable={false}
                            scale={item.scale || [1, 1, 1]}
                            position={[item.x, 0, item.z]}
                            onClick={handleClick}
                            isSelected={selectedObjectNameGlobal === item.name}
                            colorHelper={colorHelper}
                        />
                    )
                }
            })}
        </group>
    );
};
